/** @jsx jsx */

import { jsx } from '@emotion/core';
import { Alert, Margin } from '@zapier/design-system';

import { PASSING_MESSAGE_LABELS } from './constants';

type Props = {
  show: boolean;
  type: string;
};

const defaultProps = {
  type: 'alerts',
};

const mapTypeToLabel = (type: string) => PASSING_MESSAGE_LABELS[type];

function PassingMessage({ show, type }: Props) {
  return show ? (
    <aside>
      <Margin margin="0px 0px 20px 0px">
        <Alert
          status="success"
          title={`Your integration currently has no ${mapTypeToLabel(type)}!`}
        >
          The most recently run validation found no {mapTypeToLabel(type)} to
          address. Re-validate your integration to see if there are any new
          items.
        </Alert>
      </Margin>
    </aside>
  ) : null;
}

PassingMessage.defaultProps = defaultProps;

export default PassingMessage;
